import { render, staticRenderFns } from "./OfferReminderSite.vue?vue&type=template&id=63d32c0c&"
import script from "./OfferReminderSite.vue?vue&type=script&lang=js&"
export * from "./OfferReminderSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d32c0c')) {
      api.createRecord('63d32c0c', component.options)
    } else {
      api.reload('63d32c0c', component.options)
    }
    module.hot.accept("./OfferReminderSite.vue?vue&type=template&id=63d32c0c&", function () {
      api.rerender('63d32c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OfferReminderSite.vue"
export default component.exports